var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-10',{attrs:{"color":['rgba(46, 96, 153, 1)', 'rgba(124, 231, 253, 1)']}},[_c('dv-charts',{attrs:{"option":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }